import axios from "axios"
import { BaseUrl } from "../Config/config"

export const dashboard = (companyKey) => {
    return axios.get(`${BaseUrl}/dashboard?company_key=${companyKey}`)
}

export const activeUsers = (companyKey, activeUsers) => {
    return axios.get(`${BaseUrl}/active-users?company_key=${companyKey}&active_users=${activeUsers}`)
}

export const sessionPeriod = (companyKey, sessionPeriod) => {
    return axios.get(`${BaseUrl}/session-period?company_key=${companyKey}&session_period=${sessionPeriod}`)
}
